import React from 'react'
import "./NewEmailTemplate.css"
const NewEmailTemplate = () => {
  return (
    <div>
  
    </div>
  )
}

export default NewEmailTemplate
